export default __webpack_public_path__ + "static/media/add-announcement-disabled.8e1e25e1.svg";